const ALWAYS_HIDDEN = new Set([
  'tenant_id','company_id','organization_id','workspace_id',
  'created_by','updated_by','deleted_at','deleted_by',
  'is_deleted','is_archived',
  'certifications',
]);

export function isHiddenColumn(
  column: string,
  opts?: { showIds?: boolean; showAudit?: boolean }
): boolean {
  const c = column.toLowerCase();

  if (ALWAYS_HIDDEN.has(c)) return true;

  // UUID-style foreign/primary key columns
  if (!opts?.showIds && c.endsWith('_id')) return true;
  // Bare "id" primary key
  if (!opts?.showIds && c === 'id') return true;

  // Audit timestamps
  if (!opts?.showAudit && (c === 'created_at' || c === 'updated_at')) {
    return true;
  }

  return false;
}
